import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence, type Auth } from 'firebase/auth';
import { getFunctions, type Functions } from 'firebase/functions';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { firebaseWebConfig, FUNCTIONS_REGION } from './config';

/** Lazily-initialized singletons. Both portals import these via getters. */
let _app: FirebaseApp | null = null;
let _auth: Auth | null = null;
let _functions: Functions | null = null;
let _firestore: Firestore | null = null;

export function getApp(): FirebaseApp {
  if (!_app) _app = initializeApp(firebaseWebConfig);
  return _app;
}

export function getAuthClient(): Auth {
  if (!_auth) {
    _auth = getAuth(getApp());
    // CO 2026-08-20: force localStorage persistence so the Firebase auth
    // session survives a full-page redirect (Stripe Checkout → back to
    // dj-provider). Default is sessionStorage which some browsers clear
    // during cross-site redirect flows, causing the sign-in-loop-on-return
    // bug CO hit after Stripe card entry. Fire-and-forget — setPersistence
    // returns a promise but subsequent auth ops queue behind it.
    setPersistence(_auth, browserLocalPersistence).catch(() => { /* ignore */ });
  }
  return _auth;
}

export function getFunctionsClient(): Functions {
  if (!_functions) _functions = getFunctions(getApp(), FUNCTIONS_REGION);
  return _functions;
}

export function getFirestoreClient(): Firestore {
  if (!_firestore) _firestore = getFirestore(getApp());
  return _firestore;
}
